import React, { useState } from 'react';

const Summary = () => {
    const [expanded, setExpanded] = useState(false);

    return (
        <div className="bg-yellow-100 border-l-4 border-pcc-black text-yellow-700 p-4 mb-4 max-w-screen-lg mx-auto rounded-md shadow-sm">
            <h3 className="font-bold text-lg mb-1 text-pcc-black">IMPORTANT INFORMATION</h3>
            <p className="text-sm mb-2 text-pcc-black">
                <strong>For anyone taking ART, ECON, ENGL, or HIST courses:</strong><br></br>
                Starting in Fall 2026, some course numbers and titles will change to align with the new <a href="https://pasadena.edu/academics/common-course-numbering/index.php" className="underline text-blue-800 hover:text-blue-600" target="_blank" rel="noopener noreferrer">Common Course Number (CCN) system</a>.
            </p>

            <p className="text-sm mb-2 text-pcc-black">
                Find out if your course is affected —{' '}
                <button
                    onClick={() => setExpanded(!expanded)}
                    className="text-sm underline text-pcc-black focus:outline-none"
                >
                    {expanded ? 'Hide course equivalencies ▲' : 'Show course equivalencies ▼'}
                </button>{' '}
            </p>

            {expanded && (
                <div className="mt-4 overflow-x-auto">
                    <table className="min-w-full text-sm text-left text-pcc-black border-collapse border border-pcc-black">
                        <thead>
                            <tr>
                                <th className="border border-pcc-black px-2 py-1 font-bold">PCC Subject and Number</th>
                                <th className="border border-pcc-black px-2 py-1 font-bold">PCC Title</th>
                                <th className="border border-pcc-black px-2 py-1 font-bold">CCN Subject and Number</th>
                                <th className="border border-pcc-black px-2 py-1 font-bold">CCN Course Title</th>
                            </tr>
                        </thead>
                        <tbody>
                            {[
                                ['ART 001A', 'History of Western Art - Prehistoric through Medieval', 'ARTH C1100', 'Survey of Art from Prehistory to the Medieval Era'],
                                ['ART 001B', 'History of Western Art - Renaissance Through Contemporary', 'ARTH C1200', 'Survey of Art from the Renaissance to Contemporary'],
                                ['ECON 001A', 'Principles of Macroeconomics', 'ECON C2002', 'Principles of Macroeconomics'],
                                ['ECON 001AH', 'Honors Principles of Macroeconomics', 'ECON C2002H', 'Principles of Macroeconomics-Honors'],
                                ['ECON 001B', 'Principles of Microeconomics', 'ECON C2001', 'Principles of Microeconomics'],
                                ['ECON 001BH', 'Honors Principles of Microeconomics', 'ECON C2001H', 'Principles of Microeconomics-Honors'],
                                ['ENGL 001B', 'Reading and Composition', 'ENGL C1003', 'Critical Thinking and Writing through Literature'],
                                ['ENGL 001BH', 'Honors Reading and Composition', 'ENGL C1003H', 'Critical Thinking and Writing through Literature-Honors'],
                                ['HIST 007A', 'United States History to 1876', 'HIST C1001', 'United States History to 1877'],
                                ['HIST 007AH', 'Honors United States History to 1876', 'HIST C1001H', 'United States History to 1877-Honors'],
                                ['HIST 007B', 'United States History from 1876', 'HIST C1002', 'United States History since 1865'],
                                ['HIST 007BH', 'Honors United States History from 1876', 'HIST C1002H', 'United States History since 1865-Honors'],
                            ].map(([pccNum, pccTitle, ccnNum, ccnTitle]) => (
                                <tr key={pccNum}>
                                    <td className="border border-pcc-black px-2 py-1">{pccNum}</td>
                                    <td className="border border-pcc-black px-2 py-1">{pccTitle}</td>
                                    <td className="border border-pcc-black px-2 py-1">{ccnNum}</td>
                                    <td className="border border-pcc-black px-2 py-1">{ccnTitle}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}
        </div>
    );
};

export default Summary;